import React, { Dispatch } from 'react';
import { CategoryFilterGroupView, CategoryFilterGroupViewProps } from './CategoryFilterGroup.view';
import { CategoryColor } from '../../../models/graphql';
import { TimeslotFilterAction } from '../../../models/calendar';

export type CategoryFilterGroupControllerProps = Omit<
  CategoryFilterGroupViewProps,
  'categories' | 'setSelectedFilter'
> & {
  showOutOfSeason: boolean;
  dispatchFilters: Dispatch<TimeslotFilterAction>;
  categories: CategoryType[];
};

export type CategoryType = {
  id: string;
  name: string;
  archived: boolean;
  color: CategoryColor;
  seasonal: boolean;
  seasonalStartDate: string | null | undefined;
  seasonalEndDate: string | null | undefined;
  seasonallyPaused: boolean;
};

export const CategoryFilterGroupController = (props: CategoryFilterGroupControllerProps): JSX.Element => {
  const setSelectedFilter = (id: string) => {
    if (props.isMobile) {
      props.dispatchFilters({ type: 'mobileCategories', payload: id || null });
    } else {
      props.dispatchFilters({ type: 'categories', payload: id });
    }
  };

  const categories =
    props.categories.filter((category: CategoryType) => {
      const isInSeason = !category.seasonallyPaused;

      return props.showOutOfSeason ? true : isInSeason === !props.showOutOfSeason;
    }) || [];

  const viewProps: CategoryFilterGroupViewProps = {
    ...props,
    categories,
    setSelectedFilter
  };
  return <CategoryFilterGroupView {...viewProps} />;
};
